import React from "react";
import Link from "components/Link";
import Box from "components/global/Box";
import { UnorderedList } from "components/Lists";
import NavHeading from "components/navigation/NavHeading";

const WritingMenu = (props) => {
  return (
    <>
      <Box width={[1 / 3]}>
        <NavHeading>Foundation</NavHeading>

        <UnorderedList unstyled>
          <li>
            <Link to="/writing/our-brand-voice">Our brand voice</Link>
          </li>
          <li>
            <Link to="/writing/tone-of-voice">Tone of voice</Link>
          </li>
          <li>
            <Link to="/writing/faq">FAQ</Link>
          </li>
        </UnorderedList>
      </Box>

      <Box width={[1 / 3]}>
        <NavHeading>Specific guidelines</NavHeading>

        <UnorderedList unstyled>
          <li>
            <Link to="/writing/grammar-and-mechanics">
              Grammar and mechanics
            </Link>
          </li>
        </UnorderedList>
      </Box>
    </>
  );
};

export default WritingMenu;
